const transformPhoneNumber = (phone) => {
  const noSpaces = phone.replace(/\s/g, "");
  return noSpaces.replace(/\d{3,4}?(?=.\d\d)/g, "$& ");
};

export { transformPhoneNumber };
//# sourceMappingURL=bundle.esm3.js.map
